import { IconButton, Link as MuiLink, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment-timezone';
import React from 'react';
import { Link } from 'react-router-dom';
import { useBundlePackageMutation } from '../../hooks/queries/useBundlePackages';
import useConfirmDialog from '../../hooks/useConfirmDialog';
import settings from '../../services/settings';
import { IBundlePackage } from '../../services/types';
import { RouteNames } from '../config';

interface IProps {
  bundles?: IBundlePackage[];
  onRowClick: (bundle: IBundlePackage) => void;
}

const BundlePackageList = (props: IProps): JSX.Element => {
  const { bundles, onRowClick } = props;

  const confirm = useConfirmDialog();

  const { remove } = useBundlePackageMutation();

  const handleDeleteClick = (bundle: IBundlePackage) => {
    const { storyId, id: bundleId } = bundle;

    if (!storyId || !bundleId) {
      return;
    }

    confirm.open({
      onProceed: async () => remove.mutate(bundle),
    });
  };

  const handleStoryLinkClick = (bundle: IBundlePackage) => {
    window.open(`${settings.getCrewURI()}/stories/${bundle.storyId}`, '_blank');
  };

  const handleRowClick = (bundle: IBundlePackage) => onRowClick(bundle);

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">Story Id</TableCell>
            <TableCell align="center">Title</TableCell>
            <TableCell align="center">Bundles</TableCell>
            <TableCell align="center">Remain Episodes</TableCell>
            <TableCell align="center" size="small" padding="none">
              Display All Remain
              <br />
              Episodes?
            </TableCell>
            <TableCell align="center">Created at</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bundles &&
            bundles.map(bundle => (
              <TableRow
                key={bundle.id}
                component={Link}
                hover
                to={`${RouteNames.BundlePackage}/v/${bundle.storyId}`}
                onClick={() => handleRowClick(bundle)}
              >
                <TableCell align="center">{bundle.id}</TableCell>
                <TableCell align="center">
                  <MuiLink
                    component="button"
                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleStoryLinkClick(bundle);
                    }}
                  >
                    {bundle.storyId}
                  </MuiLink>
                </TableCell>
                <TableCell>{bundle.story?.title}</TableCell>
                <TableCell align="center">
                  {bundle.prices
                    ?.map(p => p.episodeNum)
                    .filter(n => n > 0)
                    .sort((a, b) => a - b)
                    .join(', ')}
                </TableCell>
                <TableCell align="center">
                  {bundle.minRemainEpisodesNumber ? `${bundle.minRemainEpisodesNumber} ~ ${bundle.maxRemainEpisodesNumber}` : '-'}
                </TableCell>
                <TableCell align="center">{bundle.showRemainAll ? 'Y' : 'N'}</TableCell>
                <TableCell align="center">{moment(bundle.createdAt).format('llll')}</TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDeleteClick(bundle);
                    }}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default BundlePackageList;
